<div class="upload">
    <div class="upload_position">
        <ng-content></ng-content>
    </div>
    <p-fileupload
        class="upload_position"
        mode="basic"
        [accept]="acceptTypes()"
        [customUpload]="true"
        [fileLimit]="1"
        [chooseStyleClass]="choseStyleClassSignal()"
        [disabled]="disabled() || inProgress()"
        [chooseLabel]="label() ? (label()! | translate) : ''"
        [auto]="true"
        (uploadHandler)="onUpload($event)"
    >
        <ng-template #chooseicon>
            <app-icon [icon]="iconSignal()"></app-icon>
        </ng-template>
    </p-fileupload>
</div>
